/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Image } from './Image'
import { ImageFromJSON, ImageFromJSONTyped, ImageToJSON } from './Image'

/**
 *
 * @export
 * @interface Author
 */
export interface Author {
  /**
   *
   * @type {string}
   * @memberof Author
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof Author
   */
  position: string
  /**
   *
   * @type {Image}
   * @memberof Author
   */
  avatar: Image
}

/**
 * Check if a given object implements the Author interface.
 */
export function instanceOfAuthor(value: object): value is Author {
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('position' in value) || value['position'] === undefined) return false
  if (!('avatar' in value) || value['avatar'] === undefined) return false
  return true
}

export function AuthorFromJSON(json: any): Author {
  return AuthorFromJSONTyped(json, false)
}

export function AuthorFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Author {
  if (json == null) {
    return json
  }
  return {
    name: json['name'],
    position: json['position'],
    avatar: ImageFromJSON(json['avatar']),
  }
}

export function AuthorToJSON(value?: Author | null): any {
  if (value == null) {
    return value
  }
  return {
    name: value['name'],
    position: value['position'],
    avatar: ImageToJSON(value['avatar']),
  }
}
